import { Component, OnInit } from '@angular/core';
import { LdsEventBusService } from '../../services/lds-event-bus.service';
import { LdsUserService } from '../../services/lds-user.service';
@Component({
    selector: 'lds-energy-status',
    templateUrl: './energy-status.component.html',
    styleUrls: ['./energy-status.component.css'],
    standalone: false
})
export class EnergyStatusComponent implements OnInit {
    toDisplay: Array<any> = [{
        name: '7 days Total',
        value: 0,
        unit: 'kWh'
    }, {
        name: 'Average Daily',
        value: 0,
        unit: 'kWh'
    }, {
        name: 'Overall Cost',
        value: 0,
        unit: String.fromCharCode(163)
    }, {
        name: 'Carbon Footprint',
        value: 0,
        unit: 'kg of CO²'
    }];
    constructor(private eventBus: LdsEventBusService, private user: LdsUserService) { }

    ngOnInit() {
        this.onTimespanChange();
        this.eventBus.subscribe('overview-status-update', (data) => {
          if (data) {
            this.eventBus.subscribe('user-settings-loaded', (settings) => {
                if (settings) {

                  const calculatedTotal = data.length ? data.map((a) => a.value).reduce((a, b) => a + b) : 0;
                  const average = (calculatedTotal / 7);
                  // Get Unit Price or set to default
                  const energySettings = settings.settings.find(setting => setting.label === 'Energy');
                  const energySettingItem = energySettings.items.find(energySetting => energySetting.label === 'Unit Rate');
                  const unitPrice = energySettingItem ? energySettingItem.value : 0.12;
                  // End Get Unir Price
                  const totalCost = unitPrice * calculatedTotal;
                  const totalCarbon = calculatedTotal * 0.309;
                  this.toDisplay[0].value = calculatedTotal.toFixed(2);
                  this.toDisplay[1].value = average.toFixed(2);
                  this.toDisplay[2].value = totalCost.toFixed(2);
                  this.toDisplay[3].value = totalCarbon.toFixed(2);
                }
            });
          }
        });
    }

    onTimespanChange(){
        this.eventBus.subscribe("overview-timespan-change", (timespan) => {
            if (!timespan){
                timespan = 'weekly';
            }

            switch(timespan){
                case 'weekly':
                    this.toDisplay[0].name = "7 Days Total";
                    break;
                case 'monthly':
                    this.toDisplay[0].name = "1 Month Total";
                    break;   
                case "custom":
                    this.toDisplay[0].name = "Custom Total";    
            }
        })
    }

}
